import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  it: {
    // Header / Nav
    brand: "Spirito Libero",
    brandSub: "Lago Maggiore",
    langToggle: "EN",

    // Hero
    heroTag: "Passeggiata in Quad",
    heroTitle1: "SPIRITO",
    heroTitle2: "LIBERO.",
    heroTitle3: "LAGO MAGGIORE.",
    heroSubtitle: "Escursioni in quad tra i sentieri panoramici del Lago Maggiore. Natura, adrenalina e libertà.",
    bookSingle: "Tour Singolo — €115",
    bookDouble: "Tour Doppio — €165",

    // Tours
    toursTag: "I Nostri Tour",
    toursTitle1: "SCEGLI LA TUA",
    toursTitle2: "AVVENTURA",
    tourSingleName: "TOUR SINGOLO",
    tourDoubleName: "TOUR DOPPIO",
    tourSingleDesc: "Guida il tuo quad in autonomia tra i sentieri del Lago Maggiore.",
    tourDoubleDesc: "Condividi l'avventura: pilota + passeggero sullo stesso quad.",
    tourSinglePersons: "1 Persona / 1 Quad",
    tourDoublePersons: "2 Persone / 1 Quad",
    duration: "3 ore",
    bookNow: "PRENOTA ORA",
    minAge: "Età minima: 8 anni",
    tourMottaroneName: "TOUR MOTTARONE",
    tourMottaroneDesc: "Dal lago alla vetta: la scalata in quad più epica del Lago Maggiore. In cima al Mottarone lo sguardo abbraccia sette laghi e le Alpi.",
    mottaroneBadge: "Su Richiesta",
    mottaroneOnlyDates: "Solo date selezionate",
    mottaroneSingleLabel: "Quad Singolo",
    mottaroneDoubleLabel: "Quad Doppio",
    mottaroneSingleSub: "1 persona / 1 quad",
    mottaroneDoubleSub: "Pilota + passeggero / 1 quad",
    mottaroneNoDates: "Nessuna data disponibile al momento. Le prossime uscite saranno pubblicate presto!",
    mottaroneStepDate: "1. Scegli la Data Disponibile",
    mottaroneStepType: "2. Scegli la Formula",
    mottaroneStepQuads: "3. Numero Quad",
    mottaroneStepData: "4. I Tuoi Dati",
    mottaroneAdvance: "Prenotazione con minimo 7 giorni di anticipo",
    mottaroneErrorBooking: "Errore nella prenotazione. Ricorda: minimo 7 giorni di anticipo.",
    tabMottarone: "Mottarone",
    tabStats: "Statistiche",

    // Booking
    bookingTitle: "PRENOTA IL TUO TOUR",
    step1: "1. Scegli la Data",
    step2: "2. Scegli l'Orario",
    step3: "3. I Tuoi Dati",
    loading: "Caricamento...",
    quadAvailable: "quad disp.",
    videoRecordo: "VIDEO RICORDO",
    videoDesc: "Riprese professionali del tour",
    fullName: "Nome Completo",
    email: "Email",
    phone: "Telefono",
    numQuads: "Numero Quad",
    licenseBLabel: "Confermo di possedere la Patente B (obbligatorio)",
    licenseBRequired: "Patente B obbligatoria per guidare il quad",
    termsLabel: "Accetto i Termini e Condizioni (obbligatorio)",
    termsRequired: "Lettura e accettazione obbligatoria",
    privacyLabel: "Accetto la Privacy Policy (obbligatorio)",
    privacyRequired: "Lettura e accettazione obbligatoria",
    termsError: "Devi accettare i Termini e Condizioni",
    privacyError: "Devi accettare la Privacy Policy",
    summary: "Riepilogo",
    tour: "Tour",
    date: "Data",
    time: "Orario",
    quads: "Quad",
    name: "Nome",
    total: "Totale",
    payConfirm: "PAGA E CONFERMA",
    selectDateTime: "Seleziona data e orario",
    fillAllFields: "Compila tutti i campi",
    licenseBError: "Devi confermare la Patente B",
    errorBooking: "Errore nella prenotazione. Ricorda: minimo 48h di anticipo.",
    errorSlots: "Errore nel caricamento degli slot",
    noQuadsAvailable: "Quad non disponibili per questo slot",
    selectedDate: "Data selezionata:",

    // Confirmation
    confirmed: "CONFERMATA",
    confirmSubtitle: "La tua avventura ti aspetta!",
    verifying: "Verifica pagamento in corso...",
    verifyTitle: "VERIFICA IN CORSO",
    verifyDesc: "Il pagamento potrebbe richiedere qualche minuto. Riceverai conferma via email.",
    backHome: "TORNA ALLA HOME",
    videoIncluded: "Video Ricordo incluso",
    bookingId: "ID Prenotazione",
    licenseB: "Patente B",
    yes: "Sì",
    no: "No",

    // Admin
    adminTitle: "Spirito Libero Admin",
    adminAccess: "ACCESSO ADMIN",
    password: "Password",
    enter: "ENTRA",
    wrongPassword: "Password errata",
    logout: "Esci",
    statsTotal: "Totali",
    statsGross: "Lordo",
    statsFee: "Fee Mgmt",
    statsNet: "Netto",
    statsConfirmed: "Confermati",
    statsToday: "Oggi",
    tabBookings: "Prenotazioni",
    tabSlots: "Disponibilità",
    searchClient: "Cerca cliente...",
    allStatuses: "Tutti gli stati",
    statusConfirmed: "Confermati",
    statusPending: "In attesa",
    statusCancelled: "Cancellati",
    noBookings: "Nessuna prenotazione trovata",
    colDate: "Data",
    colTime: "Ora",
    colTour: "Tour",
    colClient: "Cliente",
    colContact: "Contatto",
    colPrice: "Prezzo",
    colFee: "Fee",
    colNet: "Netto",
    colStatus: "Status",
    colActions: "Azioni",
    selectDateConfig: "Seleziona una data per configurare gli slot",
    timeSlots: "Fasce Orarie",
    maxQuad: "Max Quad:",
    save: "SALVA",
    close: "CHIUDI",
    reopen: "RIAPRI",
    reset: "Reset",
    override: "override",
    closed: "chiuso",
    slotUpdated: "Slot aggiornato",
    slotReset: "Slot ripristinato",
    errorSave: "Errore salvataggio",
    errorReset: "Errore ripristino",
    errorLoadBookings: "Errore caricamento prenotazioni",
    statusUpdated: "Status aggiornato",
    errorUpdateStatus: "Errore aggiornamento status",
    bookings: "prenotazioni",
    configFor: "Configurazione per:",

    // Footer
    footerRights: "© 2026 Spirito Libero Lago Maggiore. Tutti i diritti riservati.",
    footerPowered: "Powered & Developed by VibeTech Studio",
  },
  en: {
    brand: "Spirito Libero",
    brandSub: "Lago Maggiore",
    langToggle: "IT",

    heroTag: "Quad Ride",
    heroTitle1: "SPIRITO",
    heroTitle2: "LIBERO.",
    heroTitle3: "LAGO MAGGIORE.",
    heroSubtitle: "Quad excursions along the scenic trails of Lake Maggiore. Nature, adrenaline and freedom.",
    bookSingle: "Single Tour — €115",
    bookDouble: "Double Tour — €165",

    toursTag: "Our Tours",
    toursTitle1: "CHOOSE YOUR",
    toursTitle2: "ADVENTURE",
    tourSingleName: "SINGLE TOUR",
    tourDoubleName: "DOUBLE TOUR",
    tourSingleDesc: "Drive your own quad through the trails of Lake Maggiore.",
    tourDoubleDesc: "Share the adventure: driver + passenger on the same quad.",
    tourSinglePersons: "1 Person / 1 Quad",
    tourDoublePersons: "2 People / 1 Quad",
    duration: "3 hours",
    bookNow: "BOOK NOW",
    minAge: "Minimum age: 8 years",
    tourMottaroneName: "MOTTARONE TOUR",
    tourMottaroneDesc: "From the lake to the summit: the most epic quad climb on Lake Maggiore. From the top of Mottarone your gaze embraces seven lakes and the Alps.",
    mottaroneBadge: "On Request",
    mottaroneOnlyDates: "Selected dates only",
    mottaroneSingleLabel: "Single Quad",
    mottaroneDoubleLabel: "Double Quad",
    mottaroneSingleSub: "1 person / 1 quad",
    mottaroneDoubleSub: "Driver + passenger / 1 quad",
    mottaroneNoDates: "No dates available at the moment. Upcoming rides will be published soon!",
    mottaroneStepDate: "1. Choose an Available Date",
    mottaroneStepType: "2. Choose Your Option",
    mottaroneStepQuads: "3. Number of Quads",
    mottaroneStepData: "4. Your Details",
    mottaroneAdvance: "Booking at least 7 days in advance",
    mottaroneErrorBooking: "Booking error. Remember: minimum 7 days in advance.",
    tabMottarone: "Mottarone",
    tabStats: "Statistics",

    bookingTitle: "BOOK YOUR TOUR",
    step1: "1. Choose Date",
    step2: "2. Choose Time",
    step3: "3. Your Details",
    loading: "Loading...",
    quadAvailable: "quads avail.",
    videoRecordo: "VIDEO SOUVENIR",
    videoDesc: "Professional tour footage",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    numQuads: "Number of Quads",
    licenseBLabel: "I confirm I hold a B Driving License (required)",
    licenseBRequired: "B Driving License required to drive the quad",
    termsLabel: "I accept the Terms & Conditions (required)",
    termsRequired: "Reading and acceptance required",
    privacyLabel: "I accept the Privacy Policy (required)",
    privacyRequired: "Reading and acceptance required",
    termsError: "You must accept the Terms & Conditions",
    privacyError: "You must accept the Privacy Policy",
    summary: "Summary",
    tour: "Tour",
    date: "Date",
    time: "Time",
    quads: "Quads",
    name: "Name",
    total: "Total",
    payConfirm: "PAY & CONFIRM",
    selectDateTime: "Select date and time",
    fillAllFields: "Fill in all fields",
    licenseBError: "You must confirm your B Driving License",
    errorBooking: "Booking error. Remember: minimum 48h in advance.",
    errorSlots: "Error loading slots",
    noQuadsAvailable: "No quads available for this slot",
    selectedDate: "Selected date:",

    confirmed: "CONFIRMED",
    confirmSubtitle: "Your adventure awaits!",
    verifying: "Verifying payment...",
    verifyTitle: "VERIFICATION IN PROGRESS",
    verifyDesc: "Payment may take a few minutes. You will receive email confirmation.",
    backHome: "BACK TO HOME",
    videoIncluded: "Video Souvenir included",
    bookingId: "Booking ID",
    licenseB: "License B",
    yes: "Yes",
    no: "No",

    adminTitle: "Spirito Libero Admin",
    adminAccess: "ADMIN ACCESS",
    password: "Password",
    enter: "ENTER",
    wrongPassword: "Wrong password",
    logout: "Logout",
    statsTotal: "Total",
    statsGross: "Gross",
    statsFee: "Mgmt Fee",
    statsNet: "Net",
    statsConfirmed: "Confirmed",
    statsToday: "Today",
    tabBookings: "Bookings",
    tabSlots: "Availability",
    searchClient: "Search client...",
    allStatuses: "All statuses",
    statusConfirmed: "Confirmed",
    statusPending: "Pending",
    statusCancelled: "Cancelled",
    noBookings: "No bookings found",
    colDate: "Date",
    colTime: "Time",
    colTour: "Tour",
    colClient: "Client",
    colContact: "Contact",
    colPrice: "Price",
    colFee: "Fee",
    colNet: "Net",
    colStatus: "Status",
    colActions: "Actions",
    selectDateConfig: "Select a date to configure slots",
    timeSlots: "Time Slots",
    maxQuad: "Max Quad:",
    save: "SAVE",
    close: "CLOSE",
    reopen: "REOPEN",
    reset: "Reset",
    override: "override",
    closed: "closed",
    slotUpdated: "Slot updated",
    slotReset: "Slot reset",
    errorSave: "Save error",
    errorReset: "Reset error",
    errorLoadBookings: "Error loading bookings",
    statusUpdated: "Status updated",
    errorUpdateStatus: "Error updating status",
    bookings: "bookings",
    configFor: "Configuration for:",

    footerRights: "© 2026 Spirito Libero Lago Maggiore. All rights reserved.",
    footerPowered: "Powered & Developed by VibeTech Studio",
  },
};

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("sl_lang");
    if (saved) return saved;
    const browserLang = navigator.language?.slice(0, 2);
    return browserLang === "en" ? "en" : "it";
  });

  useEffect(() => {
    localStorage.setItem("sl_lang", lang);
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations["it"]?.[key] || key;
  const toggleLang = () => setLang((l) => (l === "it" ? "en" : "it"));

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
